import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { DataTieringRepositories } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { REPOSITORIES_QUERY_KEY } from "../constants";
const fetchCredentials = (repositoryName) => DataTieringRepositories.getCredentials(repositoryName);
const useRepositoryCredentials = (repositoryName) => {
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery({
    queryKey: [REPOSITORIES_QUERY_KEY, "credentials", repositoryName],
    queryFn: () => fetchCredentials(repositoryName),
    retry: false,
    staleTime: 0
  });
  const updateCredentials = useMutation({
    mutationFn: (credentials) => DataTieringRepositories.updateCredentials(
      repositoryName,
      credentials
    ),
    onSuccess: () => {
      UserNotification.success(`Credentials for repository "${repositoryName}" have been saved.`);
      queryClient.invalidateQueries({ queryKey: [REPOSITORIES_QUERY_KEY] });
    }
  });
  return {
    credentials: {
      data,
      isLoading,
      error
    },
    onUpdateCredentials: updateCredentials.mutateAsync
  };
};
export default useRepositoryCredentials;
